// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { useGetApi } from "../client";
import { useCallback } from "react";

export function useStopTwilioCall(): (
  kontaktaufnahmeId: string
) => Promise<void> {
  const getAPI = useGetApi();
  return useCallback(
    async (kontaktaufnahmeId) =>
      (await getAPI()).kontaktaufnahme.stopTwilioCall({ kontaktaufnahmeId }),
    [getAPI]
  );
}
